import Bowser from 'bowser';

const bowser = Bowser.getParser(window.navigator.userAgent);

export function supportsWebapp() {
  return bowser.satisfies({
    chrome: '>70',
    chromium: '>70',
    edge: '>=79',
  });
}

export function isMobileOrTablet() {
  return bowser.is('mobile') || bowser.is('tablet');
}

export function isAppleMobileDevice() {
  if (bowser.is('ios')) {
    return true;
  }
  // iPads now return 'desktop' and 'macOS' in user-agent
  if (bowser.is('macos') && bowser.is('desktop')) {
    return navigator.maxTouchPoints > 1;
  }
  return false;
}

export function isAndroidMobileDevice() {
  return bowser.is('android') && isMobileOrTablet();
}
